import { clsx } from 'clsx';
import { AnchorHTMLAttributes, DetailedHTMLProps } from 'react';
import Link from 'next/link';

export default function PaginationButton({
  href = '/',
  className,
  children,
  ...props
}: DetailedHTMLProps<
  AnchorHTMLAttributes<HTMLAnchorElement>,
  HTMLAnchorElement
>) {
  return (
    <Link
      href={href}
      aria-selected={props['aria-selected']}
      rel={props.rel}
      className={clsx(
        'hover:bg-grey bg-grey flex h-10 min-w-[40px] select-none items-center justify-center disabled:hover:bg-white md:bg-white',
        className
      )}
    >
      {children}
    </Link>
  );
}
